import { useCallback } from 'react'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { TaxonomyTranslation, TaxonomyTranslationStatus } from '@taxonomy-translation/types'
import { formatInputNames, getPercent, getTitleFromSeconds } from '@taxonomy-translation/utils'
import { ROUTES } from 'routes'
import { ColorIndicator } from './color-indicator'
import { ListItem } from './list-item'
import { t } from '@lingui/core/macro'

interface Props {
  item: TaxonomyTranslation
}

export const TranslationListItem = ({ item }: Props) => {
  const history = useHistory()

  const handleRedirectOnDetails = useCallback(() => {
    history.push(`${ROUTES.TAXONOMY_TRANSLATION}/${item.uuid}`)
  }, [history])

  return (
    <ListItem
      onClick={handleRedirectOnDetails}
      disabled={item.status === TaxonomyTranslationStatus.Failed}
    >
      <ListItem.ColumnWrapper>
        <div className="flex flex-col">
          <ListItem.Title>{item.name}</ListItem.Title>
          <ListItem.Subtitle>{formatInputNames(item.inputs).join(', ')}</ListItem.Subtitle>
        </div>
        <ListItem.Column>
          <ListItem.Row>
            <ListItem.Title className="text-sm">{t`Created by:`}</ListItem.Title>{' '}
            <ListItem.Subtitle>{item.createdByName}</ListItem.Subtitle>
          </ListItem.Row>
          <ListItem.Row>
            <ListItem.Title className="text-sm">{t`Translation date:`}</ListItem.Title>{' '}
            <ListItem.Subtitle>
              {moment(item.createdAt).format('MMM D, YYYY h:mma')}
            </ListItem.Subtitle>
          </ListItem.Row>
        </ListItem.Column>
        <ListItem.Column>
          <ListItem.Row>
            <ListItem.Title className="text-sm">{t`Status:`}</ListItem.Title>{' '}
            <ListItem.Subtitle>{item.statusLabel}</ListItem.Subtitle>
          </ListItem.Row>
          <ListItem.Row>
            {!!item.matchesMetrics?.translations && !!item.matchesMetrics?.matches && (
              <>
                <ListItem.Title className="text-sm">{t`Translation:`}</ListItem.Title>{' '}
                <ListItem.Subtitle>{`${getPercent(item.matchesMetrics?.matches, item.matchesMetrics?.translations)}% matched in ${getTitleFromSeconds(item.matchesMetrics?.durationInSeconds)}`}</ListItem.Subtitle>
              </>
            )}
          </ListItem.Row>
          <ListItem.Row>
            {item.status !== TaxonomyTranslationStatus.Failed ? (
              <>
                <ListItem.Title className="text-sm">{t`Review progress:`}</ListItem.Title>{' '}
                <ListItem.Subtitle>
                  {getPercent(item.reviewProgress?.reviewed, item.matchesMetrics?.translations)}%
                </ListItem.Subtitle>
              </>
            ) : (
              <ListItem.Subtitle>Please contact your CSM</ListItem.Subtitle>
            )}
          </ListItem.Row>
        </ListItem.Column>
      </ListItem.ColumnWrapper>
      <ColorIndicator
        status={item.status}
        progress={getPercent(item.reviewProgress?.reviewed, item.matchesMetrics?.translations)}
      />
    </ListItem>
  )
}
